import { noOp } from '@constants/empty';
import useOngoingSection from '@cont/Quiz/Taking/Common/useOngoingSection';
import styled from '@emotion/styled';
import CheckCircleLight from '@icon/CheckCircleLight';
import LockOutline from '@icon/LockOutline';
import { Spacings, Fonts } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const SectionWrapper = styled.div`
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  background-color: ${({ $isSelected }) =>
    $isSelected ? 'var(--color-base-1)' : 'var(--color-base-0)'};
  padding: 0 ${Spacings.SPACING_3B};
  margin-right: ${Spacings.SPACING_4B};
  border-radius: ${Spacings.SPACING_2B};
  display: flex;
  align-items: center;
  height: ${Spacings.SPACING_10B};
  font-size: ${Fonts.LARGE};
  color: ${({ $isCompleted, $isDisabled }) =>
    $isCompleted || $isDisabled
      ? 'var(--color-text-secondary)'
      : 'var(--color-text-primary)'};
  font-weight: ${({ $isSelected }) =>
    $isSelected ? Fonts.SEMIBOLD : Fonts.REGULAR};
  box-shadow: ${boxShadowGenerator()};
`;

const SectionIcons = styled.div`
  margin-left: ${Spacings.SPACING_2B};
  display: flex;
  align-items: center;
`;

const Section = ({ section, $isSelected, onSectionClick }) => {
  const { uid, title } = section;
  const { hasOngoingSectional, isLocked, isCompleted } = useOngoingSection(uid);

  const getSectionIcons = () => {
    if (isCompleted) {
      return <CheckCircleLight size={13} color="var(--color-text-secondary)" />;
    }

    if (isLocked) {
      return (
        <LockOutline
          width={11}
          height={14}
          color="var(--color-text-secondary)"
        />
      );
    }

    return null;
  };

  const handleSectionClick = () => {
    if (isLocked) return noOp();
    return onSectionClick(uid);
  };

  return (
    <SectionWrapper
      $isSelected={$isSelected}
      $isDisabled={isLocked}
      $isCompleted={isCompleted}
      onClick={handleSectionClick}
    >
      {title}
      {hasOngoingSectional && (isLocked || isCompleted) && (
        <SectionIcons>{getSectionIcons()}</SectionIcons>
      )}
    </SectionWrapper>
  );
};

export default Section;
